// src/components/Footer.js
import { FaFacebookF, FaInstagram, FaLine, FaWhatsapp } from 'react-icons/fa';
import appConfig from '../config/appConfig';

function Footer() {
  const { contact, social, company, currentYear } = appConfig;

  return (
    <footer className="bg-dark text-white py-4">
      <div className="container">
        <div className="row text-center text-md-start">
          {/* Contact Info - Nepal */}
          <div className="col-md-4 mb-3">
            <h5>Contact Nepal</h5>
            <p>
              Position: {contact.nepal.position}<br />
              Phone: {contact.nepal.phoneRaw}<br /><br />
              Address: {contact.nepal.address}<br />
              {contact.nepal.address2}<br />
              Email:  {contact.nepal.email}<br />
            </p>
          </div>
          {/* Contact Info - Japan */}
          <div className="col-md-4 mb-3">
            <h5>Contact Japan</h5>
            <p>
              Position: {contact.japan.position}<br />
              Phone: {contact.japan.phone1Display}<br /><br />
              Phone: {contact.japan.phone2Display}<br />
              Address: {contact.japan.address}
            </p>
          </div>

          {/* Social Links */}
          <div className="col-md-4 mb-3">
            <h5>Follow/Contact Us</h5>
            <div className="d-flex justify-content-center justify-content-md-start gap-3 fs-4">
              <a
                href={social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href={social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href={social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a
                href={social.line}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white"
                aria-label="LINE"
              >
                <FaLine />
              </a>
            </div>
          </div>
        </div>

        <hr className="bg-white opacity-25" />

        <div className="text-center">
          <small>&copy; {currentYear} {company.name}. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;